module.exports = __webpack_public_path__ + "img/team3.f534e61e.png";